module.exports = __webpack_public_path__ + "img/sound-on.385446b5.svg";